export function isNumber(n) {
    return typeof n === "number";
}
export function isString(n) {
    return typeof n === "string";
}
export function isNullOrUndef(val) {
    return val === undefined || val === null;
}
export function isNullOrEmpty(val) {
    return isNullOrUndef(val) || val === '' || val === 'null' || val === 'undefined';
}
export function removeWhiteSpace(val) {
    return val.replace(/\s/g, "_");
}
export function splitOnCamelCase(val) {
    return val.replace(/([a-z\xE0-\xFF])([A-Z\xC0\xDF])/g, '$1 $2');
}
export function idify(val) {
    return removeWhiteSpace(val).toLowerCase();
}
export function trimRight(val, charlist) {
    if (charlist === undefined)
        charlist = "\s";
    return val.replace(new RegExp("[" + charlist + "]+$"), "");
}
;
export function capitalize(val) {
    return val.charAt(0).toUpperCase() + val.slice(1);
}
export const debounce = (func, wait) => {
    //console.log(`debounce ${wait}`);
    let timeout;
    // This is the function that is returned and will be executed many times
    // We spread (...args) to capture any number of parameters we want to pass
    return function executedFunction(...args) {
        // The callback function to be executed after 
        // the debounce time has elapsed
        const later = () => {
            //console.log(`debounce later`);
            // null timeout to indicate the debounce ended
            timeout = null;
            // Execute the callback
            func(...args);
        };
        // This will reset the waiting every function execution.
        // This is the step that prevents the function from
        // being executed because it will never reach the 
        // inside of the previous setTimeout  
        clearTimeout(timeout);
        // Restart the debounce waiting period.
        // setTimeout returns a truthy value (it differs in web vs Node)
        timeout = setTimeout(later, wait);
    };
};
export function containsAllItems(array1, array2) {
    return !(except(array2, array1).length > 0);
}
export function except(array1, array2) {
    return array1.filter(x => !array2.includes(x));
}
export class Settings {
}
Settings.mapMinZoomLevel = 5; //stop them zooming out too much 
Settings.mapZoomDefault = 6; //LARGER = more zoomed
Settings.mapZoomedInDefault = 13; //LARGER = more zoomed
Settings.mapDefaultLat = 54.606039;
Settings.mapDefaultLng = -1.537400;
import L from "leaflet";
import 'leaflet.markercluster';
export function flyToResult(autoCompleteResult, mapInstance) {
    //console.log(`flyToResult gave`)
    //console.log(autoCompleteResult)
    var dest = L.latLng(autoCompleteResult.latitude, autoCompleteResult.longitude);
    mapInstance.flyTo(dest, Settings.mapZoomedInDefault /* 16 More zoomed is larger no.*/);
    //console.log(`flyToResult done`);
}
export function carParkToLocation(carPark) {
    return L.latLng(carPark.latitude, carPark.longitude);
}
export function getEmptyMarkerClusterGroup() {
    return L.markerClusterGroup({
        polygonOptions: {
            fillColor: '#1b2557',
            color: '#1b2557',
            weight: 0.5,
            opacity: 1,
            fillOpacity: 0.5
        }
    });
}
export function setBaseLayers(mapInstance) {
    var mapboxAttribution = 'Map data &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors, ' +
        'Imagery &copy; <a href="https://www.mapbox.com/">Mapbox</a>', mapboxUrl = 'https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token=pk.eyJ1IjoiYmNhbWVyb25zbWl0aCIsImEiOiJjazkydHhleDkwYWVkM2ZxeHFrMm9oOG9yIn0.E9orHowTWrNJtH31DrSIrA';
    var streets = L.tileLayer(mapboxUrl, {
        id: 'mapbox/streets-v11',
        tileSize: 512, zoomOffset: -1, maxNativeZoom: 18, maxZoom: 21, attribution: mapboxAttribution
    });
    var satelliteStreets = L.tileLayer(mapboxUrl, {
        id: 'mapbox/satellite-streets-v11',
        tileSize: 512, zoomOffset: -1, maxNativeZoom: 18, maxZoom: 21, attribution: mapboxAttribution
    });
    var baseLayers = {
        "Hybrid": satelliteStreets,
        "Streets": streets
    };
    satelliteStreets.addTo(mapInstance);
    L.control.layers(baseLayers).addTo(mapInstance); //TODO:KEY one option
    //L.control.layers(undefined, baseLayers, {position:'topleft'}).addTo(mapInstance); //TODO:KEY one option
}
export function getTileLayer() {
    return L.tileLayer('https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token=pk.eyJ1IjoiYmNhbWVyb25zbWl0aCIsImEiOiJjazkydHhleDkwYWVkM2ZxeHFrMm9oOG9yIn0.E9orHowTWrNJtH31DrSIrA', {
        attribution: 'Map data &copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors, ' +
            '<a href="https://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a>, ' +
            'Imagery &copy; <a href="https://www.mapbox.com/">Mapbox</a>',
        id: 'mapbox/streets-v11',
        tileSize: 512,
        zoomOffset: -1,
        //maxZoom: 18
        //try https://gis.stackexchange.com/questions/277770/why-empty-tiles-when-zoomed-too-much-in-leaflet-js
        maxNativeZoom: 18,
        maxZoom: 100
    });
}
